import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
// import { useLocation, useNavigate } from "react-router-dom";
import { InfoCircleFilled } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { setYesNoSelected, setYesNoSelectedOption} from '../../../redux/actions/msTeamsAction';
import { setTeamsVideoRoomResponse } from '../../../redux/actions/feedbackActions';
import { useMediaQuery } from 'react-responsive';
const translations = {
  English: {
    question: "Was the meeting room you booked a Microsoft Teams video room (MTR)?",
    note: "Note",
    description: "Microsoft Teams Video Rooms provide high quality video, audio, and content sharing for conference rooms. They include features like one-touch join, proximity join, and intelligent speakers and cameras. These systems enable seamless and equal collaboration for both in-room and remote participants. Microsoft Team Video Rooms consist of in-room compute device, cameras, microphones, and speakers.",
    noteDescription: "An MTR room should have the following: Display, Mic, Touch console, Speaker, Camera.",
    yes: "Yes",
    no: "No"
  },
  Spanish: {
    question: "¿La sala de reuniones que reservó era una sala de video de Microsoft Teams (MTR)?",
    note: "Nota",
    description: "Las salas de video de Microsoft Teams ofrecen video, audio y uso compartido de contenido de alta calidad para salas de conferencias. Incluyen funciones como unirse con un toque, unión por proximidad y altavoces y cámaras inteligentes. Estos sistemas permiten una colaboración fluida e igualitaria tanto para participantes en la sala como remotos. Las salas de video de Microsoft Teams consisten en un dispositivo de cómputo en la sala, cámaras, micrófonos y altavoces.",
    noteDescription: "Una sala MTR debe tener lo siguiente: pantalla, micrófono, consola táctil, altavoz, cámara.",
    yes: "Sí",
    no: "No"
  },
  French: {
    question: "La salle de réunion que vous avez réservée était-elle une salle de vidéo Microsoft Teams (MTR) ?",
    note: "Remarque",
    description: "Les salles de vidéo Microsoft Teams offrent une vidéo, un audio et un partage de contenu de haute qualité pour les salles de conférence. Elles incluent des fonctionnalités telles que la connexion en un seul clic, la connexion de proximité et des haut-parleurs et caméras intelligents. Ces systèmes permettent une collaboration fluide et égale pour les participants en salle et à distance. Les salles de vidéo Microsoft Teams comprennent un appareil informatique en salle, des caméras, des microphones et des haut-parleurs.",
    noteDescription: "Une salle MTR doit inclure les éléments suivants : écran, microphone, console tactile, haut-parleur, caméra.",
    yes: "Oui",
    no: "Non"
  },
  Japanese: {
    question: "予約した会議室は Microsoft Teams のビデオルーム (MTR) でしたか？",
    note: "注記",
    description: "Microsoft Teams ビデオルームは、会議室向けに高品質なビデオ、音声、コンテンツ共有を提供します。ワンタッチでの参加や近接参加、インテリジェントなスピーカーとカメラなどの機能を備え、現場とリモートの参加者がシームレスかつ平等に協力できる環境を提供します。Microsoft Teams ビデオルームには、室内用コンピューティングデバイス、カメラ、マイク、スピーカーが含まれます。",
    noteDescription: "MTR ルームには、ディスプレイ、マイク、タッチコンソール、スピーカー、カメラが必要です。",
    yes: "はい",
    no: "いいえ"
  },
  Chinese: {
    question: "您预订的会议室是 Microsoft Teams 视频会议室 (MTR) 吗？",
    note: "注意",
    description: "Microsoft Teams 视频会议室为会议室提供高质量的视频、音频和内容共享。它们包括一键加入、近距离加入和智能扬声器和摄像头等功能。这些系统为室内和远程参与者提供无缝和平等的协作。Microsoft Teams 视频会议室包括室内计算设备、摄像头、麦克风和扬声器。",
    noteDescription: "MTR 会议室应具备以下设施：显示器、麦克风、触控控制台、扬声器、摄像头。",
    yes: "是",
    no: "否"
  },
  Dutch: {
    question: "Was de vergaderruimte die u heeft geboekt een Microsoft Teams video-ruimte (MTR)?",
    note: "Opmerking",
    description: "Microsoft Teams videoruimtes bieden hoogwaardige video, audio en content-sharing voor vergaderruimtes. Ze omvatten functies zoals één-klik-deelname, nabijheid-join, en intelligente luidsprekers en camera's. Deze systemen zorgen voor naadloze en gelijke samenwerking voor zowel aanwezige als externe deelnemers. Microsoft Teams videoruimtes bestaan uit een in-room computerapparaat, camera's, microfoons en luidsprekers.",
    noteDescription: "Een MTR-ruimte moet de volgende items hebben: scherm, microfoon, touch-console, luidspreker, camera.",
    yes: "Ja",
    no: "Nee"
  },
  German: {
    question: "War der von Ihnen gebuchte Besprechungsraum ein Microsoft Teams Video-Raum (MTR)?",
    note: "Hinweis",
    description: "Microsoft Teams Video-Räume bieten hochwertige Video-, Audio- und Inhaltsfreigabe für Konferenzräume. Sie umfassen Funktionen wie one-touch join, Näherungsbeitritt und intelligente Lautsprecher und Kameras. Diese Systeme ermöglichen nahtlose und gleichberechtigte Zusammenarbeit für Teilnehmer im Raum und remote. Microsoft Teams Video-Räume bestehen aus einem Raum-Computergerät, Kameras, Mikrofonen und Lautsprechern.",
    noteDescription: "Ein MTR-Raum sollte Folgendes haben: Bildschirm, Mikrofon, Touch-Konsole, Lautsprecher, Kamera.",
    yes: "Ja",
    no: "Nein"
  }
};
 
const MicrosoftTeamsVideoRoomSection = ({ onYesNoSelect }) => {
  const {isYesNoSelectedTeams,yesNoSelectedOption} = useSelector((state) => state.msTeams);
  const [selectedOption, setSelectedOption] = useState(yesNoSelectedOption);
  const dispatch = useDispatch();
  const [hoveredButton, setHoveredButton] = useState(null);
  const selectedLanguage = useSelector((state) => state.language.selectedLanguage);
  const isMobile = useMediaQuery({ maxWidth: 768 }); 
  useEffect(() => {
    if (yesNoSelectedOption) {
      setSelectedOption(yesNoSelectedOption);
    }
  }, [yesNoSelectedOption]);
 
  const translation = translations[selectedLanguage]; 
  const getButtonStyle = (option) => {
    const isSelected = selectedOption === option;
    const isHovered = hoveredButton === option;

    return {
      marginRight: "20px",
      width: "140px",
      height: "40px",
      backgroundColor: isSelected
        ? "#D1DDEA"
        : isHovered
        ? "#E0EBF1"
        : undefined,
      color: isSelected || isHovered ? "black" : undefined,
      borderColor: isHovered ? "#CAD2D8" : undefined,
      borderWidth: "1px",
      borderStyle: "solid",
    };
  };

  const handleClick = (option) => {
    setSelectedOption(option); 
    onYesNoSelect(option); 
    dispatch(setYesNoSelected(true)); 
    dispatch(setYesNoSelectedOption(option)); 
    dispatch(
      setTeamsVideoRoomResponse(
        "Microsoft Teams Video room", 
        translations['English'].question, 
        option 
      )
    );
  }; 
  const [isDescriptionVisible, setIsDescriptionVisible] = useState(false);
 
  return (
    <section style={isMobile?{padding:'0 6%'  }:{padding:'0'}}>
        <div>
      <div style={{ display: "flex", alignItems: "center", fontSize: "12px" }}>
        <h3 style={{ margin: "0" }}>Microsoft Teams Video Room</h3>
        <InfoCircleFilled
          style={{ width: "25px", marginLeft: "10px", cursor: "pointer" }}
          onClick={() => setIsDescriptionVisible(!isDescriptionVisible)}
        />
      </div>
      {isDescriptionVisible && (
        <p style={{ fontSize: "13px", margin: "1" }}>
          {translation.description}
        </p>
      )}
    </div>
 
 
      <div style={{ marginTop: '35px' }}>
        <h3>{translation.question}</h3>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
          <div style={{ border: '1px solid', borderColor: '#0990DB', fontSize: '13px', borderRadius: '10px', backgroundColor: 'rgb(241, 250, 254)', padding: '5px' }}>
            <InfoCircleFilled style={{ width: '25px' }} />
            <strong>{translation.note} </strong>  {translation.noteDescription}
          </div>
        </div>
        <img
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/7956c72dea117d9d716e649ae075440c4c9e85c980bb5243f0a1b0d37b97c9d9?placeholderIfAbsent=true&apiKey=2bad5dddb78c4e879392057a342234a5"
          alt="Microsoft Teams video room setup"
          style={{ width: '300px', height: '180px' }}
        />
      </div>
      <div style={{ marginTop: "20px", display: "flex", gap: "20px", flexWrap: "wrap" }}>
      {/* <Button
  style={{
    marginRight: "20px",
    width: "140px",
    height: "40px",
    backgroundColor: selectedOption === "Yes" ? "#D1DDEA" : undefined,
    color: selectedOption === "Yes" ? "black" : undefined,
  }}
  className="custom-button"
  onClick={() => handleClick("Yes")}
>
  {translation.yes}
</Button>

<Button
  style={{
    marginRight: "20px",
    width: "140px",
    height: "40px",
    backgroundColor: selectedOption === "No" ? "#D1DDEA" : undefined,
    color: selectedOption === "No" ? "black" : undefined,
  }}
  className="custom-button"
  onClick={() => handleClick("No")}
>
  {translation.no}
</Button> */}

<Button
        style={getButtonStyle("Yes")}
        onMouseEnter={() => setHoveredButton("Yes")}
        onMouseLeave={() => setHoveredButton(null)}
        className="custom-button"
        onClick={() => handleClick("Yes")}
      >
        {translation.yes}
      </Button>

      <Button
        style={getButtonStyle("No")}
        onMouseEnter={() => setHoveredButton("No")}
        onMouseLeave={() => setHoveredButton(null)}
        className="custom-button"
        onClick={() => handleClick("No")}
      >
        {translation.no}
      </Button>
</div>

    </section>
  );
};
 
export default MicrosoftTeamsVideoRoomSection;